import * as ResourceApi from 'api/resources';
import {createResourceRawFiltersSelector} from 'viewOptions/selectors';

export const getPrizeEntryFilters = createResourceRawFiltersSelector(ResourceApi.Types.PrizeEntry);



// WEBPACK FOOTER //
// ./public/pages/ListWinners/selectors.js